import React from 'react';
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Typography, Divider } from '@mui/material';
import { FormikProps } from 'formik';

// Define a local FormValues interface with only the fields needed for this component
interface FormValues {
  companyName: string;
  ownerName: string;
  email: string;
  phoneNumber: string;
  position: string;
}

interface Props {
  formik: FormikProps<any>;
  position?: string[];
  onEmailBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onPhoneBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  existingClientEmail?: any;
  existingClientPhone?: any;
}

const ContactInformationSection: React.FC<Props> = ({ formik, position = [], onEmailBlur, onPhoneBlur, existingClientEmail, existingClientPhone }) => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Contact Information</Typography>
      <Divider sx={{ mb: 2 }} />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="companyName"
        name="companyName"
        label="Company Name"
        value={formik.values.companyName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.companyName && Boolean(formik.errors.companyName)}
        helperText={formik.touched.companyName && (formik.errors.companyName as string)}
        required
      />
    </Grid>
    
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="ownerName"
        name="ownerName"
        label="Decision Maker"
        value={formik.values.ownerName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.ownerName && Boolean(formik.errors.ownerName)}
        helperText={formik.touched.ownerName && (formik.errors.ownerName as string)}
        required
      />
    </Grid>
    
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth>
        <InputLabel id="position-label" required>Position</InputLabel>
        <Select
          labelId="position-label"
          id="position"
          name="position"
          value={formik.values.position || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.position && Boolean(formik.errors.position)}
          label="Position"
          required
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {position.map((position) => (
            <MenuItem key={position} value={position}>{position}</MenuItem>
          ))}
        </Select>
        {formik.touched.position && formik.errors.position ? (
          <FormHelperText error>{formik.touched.position && (formik.errors.position as string)}</FormHelperText>
        ) : (
          <FormHelperText>Select client's position</FormHelperText>
        )}
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="email"
        name="email"
        label="Email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={(e) => {
          formik.handleBlur(e);
          if (onEmailBlur) onEmailBlur(e);
        }}
        error={formik.touched.email && (Boolean(formik.errors.email) || Boolean(existingClientEmail))}
        helperText={
          (formik.touched.email && (formik.errors.email as string)) ||
          (existingClientEmail ? 'This email is already registered with another client' : '')
        }
        required
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        id="phoneNumber"
        name="phoneNumber"
        label="Phone Number"
        value={formik.values.phoneNumber}
        onChange={formik.handleChange}
        onBlur={(e) => {
          formik.handleBlur(e);
          if (onPhoneBlur) onPhoneBlur(e);
        }}
        error={formik.touched.phoneNumber && (Boolean(formik.errors.phoneNumber) || Boolean(existingClientPhone))}
        helperText={
          (formik.touched.phoneNumber && (formik.errors.phoneNumber as string)) ||
          (existingClientPhone ? 'This phone number is already registered with another client' : '')
        }
        required
      />
    </Grid>
  </>
);

export default ContactInformationSection;
